var i={maxWidth:{value:"100%"},height:{value:"auto"},objectFit:{value:"initial"},objectPosition:{value:"initial"}};export{i as image};
//# sourceMappingURL=image.js.map
